import { ReactComponent as Menu1 } from 'assets/aside/menu1.svg'
import { ReactComponent as Menu2 } from 'assets/aside/menu2.svg'
import { ReactComponent as Menu3 } from 'assets/aside/menu3.svg'
import { ReactComponent as Menu4 } from 'assets/aside/menu4.svg'
import { ReactComponent as Menu5 } from 'assets/aside/menu5.svg'
import { ReactComponent as Menu6 } from 'assets/aside/menu6.svg'
import { ReactComponent as Menu7 } from 'assets/aside/menu7.svg'
import { ReactComponent as Menu8 } from 'assets/aside/menu8.svg'
import { ReactComponent as Menu9 } from 'assets/aside/menu9.svg'
import { ReactComponent as Menu10 } from 'assets/aside/menu10.svg'

export interface IMenu {
    title: string
    titleEn: string
    url: string
    subMenu?: ISubMenu[]
    isOpen?: boolean
    icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>,
}

export interface ISubMenu {
    title: string
    url: string
}

export const menu: IMenu[] = [
    {
        title: '회원정보',
        titleEn: 'editProfile',
        url: '/mypage/editProfile',
        icon: Menu1
    },
    {
        title: '비밀번호 관리',
        titleEn: 'resetPW',
        url: '/mypage/resetPW',
        icon: Menu2
    },
    {
        title: '회사정보',
        titleEn: 'editCompany',
        url: '/mypage/editCompany',
        icon: Menu3,
    },
    {
        title: '관리자알림',
        titleEn: 'as',
        url: '/mypage/as/list',
        icon: Menu9,
    },
    {
        title: '1:1문의',
        titleEn: 'inquiry',
        url: '/mypage/inquiry/list',
        icon: Menu10,
    },
    {
        title: '공지사항',
        titleEn: 'notice',
        url: '/mypage/notice/list',
        icon: Menu4,
    },
    {
        title: '견적/운임 알림',
        titleEn: 'notification',
        url: '/mypage/notification/list',
        icon: Menu5,
    },
    {
        title: '사고/이슈 알림',
        titleEn: 'issue',
        url: '/mypage/issue/blList',
        icon: Menu6,
    },
    {
        title: '서브계정 관리',
        titleEn: 'subAccount',
        url: '/mypage/subAccount/list',
        icon: Menu7,
    },
    {
        title: '로그아웃',
        titleEn: 'logout',
        url: '',
        icon: Menu8,
    },
]